var BundleStateManager = {
    initBundleState() {
        if(!window.bundleState){
            window.bundleState = {
                bundleItems: {},
                currentQuantity: 0,
                maxBundleQuantity: 0,
                totalPrice: 0,
                totalComparePrice: 0,
                subscribers: /* @__PURE__ */ new Map(),
                bundle_product_id: "",
                bundle_variant_id: "",
                bundle_sp_id: "",
                bundle_handle: "",

                setInitialState(settings = {}) {
                    if(settings.maxBundleQuantity !== void 0) {
                        this.maxBundleQuantity = settings.maxBundleQuantity;
                    }
                    this.bundle_product_id = settings.bundle_product_id || "";
                    this.bundle_variant_id = settings.bundle_variant_id || "";
                    this.bundle_sp_id = settings.bundle_sp_id || "";
                    this.bundle_handle = settings.bundle_handle || "";
                },

                addBundleItem(itemKey, itemData) {
                    if(this.currentQuantity >= this.maxBundleQuantity) return;
                    
                    if(this.bundleItems[itemKey]) {
                        // If item already exists, update its quantity and price
                        this.bundleItems[itemKey].quantity++;
                    }
                    else{
                        this.bundleItems[itemKey] = {};
                        this.bundleItems[itemKey].itemData = itemData;
                        this.bundleItems[itemKey].quantity = 1;
                        this.bundleItems[itemKey].price = itemData.price || 0;
                        this.bundleItems[itemKey].comparePrice = itemData.compareAtPrice || 0;
                    }

                    this.currentQuantity++;
                    this.totalPrice += itemData.price || 0;
                    this.totalComparePrice += itemData.compareAtPrice || 0;
                    this.notifySubscribers("itemAdded");
                },
                
                removeBundleItem(itemKey) {
                    if(!this.bundleItems[itemKey]) return;
                    
                    this.bundleItems[itemKey].quantity--;
                    this.totalPrice -= this.bundleItems[itemKey].price;
                    this.totalComparePrice -= this.bundleItems[itemKey].comparePrice;
                    this.currentQuantity--;
                    if(this.bundleItems[itemKey].quantity <= 0) {
                        delete this.bundleItems[itemKey];
                    }
                    this.notifySubscribers("itemRemoved");
                },


                async AddToCart() {
                    if (this.currentQuantity == this.maxBundleQuantity) {
                        // Logic to add bundle items to cart
                        // This could be an API call or redirect to cart page
                        console.log("Adding to cart:", this.bundleItems);

                        const bundleProductData = {
                            productId: this.bundle_product_id,
                            variantId: this.bundle_variant_id,
                            sellingPlan: this.bundle_sp_id,
                            handle: this.bundle_handle,
                        };

                        console.log("Bundle Product Data:", bundleProductData);

                        const bundle = {
                            externalVariantId: bundleProductData.variantId,
                            externalProductId: bundleProductData.productId,
                            selections: [],
                        };

                        for(const itemKey in this.bundleItems) {
                            const item = this.bundleItems[itemKey];
                            bundle.selections.push({
                                collectionId: item.itemData.collectionId || 'default-collection-id',
                                externalProductId: item.itemData.id || 'default-product-id',
                                externalVariantId: item.itemData.variantID || 'default-variant-id',
                                quantity: item.quantity,
                                sellingPlan: item.itemData.sellingPlanID || null,
                            });
                        }

                        const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
                        const cartData = { items: cartItems };

                        await fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(cartData),
                        });
                        console.log("Bundle added to cart:", cartData);
                        window.location.href = window.Shopify.routes.root + '?viewcart=true';
                    }
                },
                notifySubscribers(changeType = null) {
                    for (const [component, callback] of this.subscribers) {
                        if (typeof callback === "function") {
                            try {
                                callback.call(component, changeType);
                            } catch (e) {
                                console.error("Error calling subscriber callback:", e);
                            }
                        }
                    }
                },
                subscribe(component, callback) {
                    if (typeof callback === "function") {
                        this.subscribers.set(component, callback);
                    }
                },
                unsubscribe(component) {
                    this.subscribers.delete(component);
                }


            };
        }
        window.bundleState.setInitialState(window.kkbSettings);
        this.bundleState = window.bundleState;
    }

}

var BundleProductCard = class extends HTMLElement {
    constructor(){
        super();
        this.bundleState = null;
        this.bindEvents();
    }
    bindEvents() {
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleQuantityDecrease = this.handleQuantityDecrease.bind(this);
        this.handleQuantityIncrease = this.handleQuantityIncrease.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
    }
    connectedCallback() {
        BundleStateManager.initBundleState.call(this);
        this.bundleState.subscribe(this, this.handleStateChange);
        this.button = this.querySelector(".button-add");
        this.product = JSON.parse(this.dataset.product || "{}"); // put data in data-product attribute in `{ productdata | json | escape}` format
        this.aside = document.querySelector("sidebar");
        this.quantitySelector = this.querySelector(".quantity-selector");

        let minPrice = Infinity;
        let sellingPlanId = null;

        try {
        // Find cheapest selling plan
        for(const spa of this.product.variants[0].selling_plan_allocations) {
            if(spa.price < minPrice) {
                minPrice = spa.price;
                sellingPlanId = spa.selling_plan_id;
            }
        }
        } catch(e) {
            console.warn("Could not parse selling plans for product:", this.product.title, e);
            // Fallback to variant price if no selling plans
            if(this.product.variants && this.product.variants[0]) {
                minPrice = this.product.variants[0].price;
            } else {
                minPrice = 0;
            }
        }

        this.itemData = {
            id: this.product.id,
            variantID: this.product.variants && this.product.variants[0] ? this.product.variants[0].id : null,
            name: this.product.title,
            subtitle: this.product.type || "",
            price: minPrice / 100, // Use selling plan price (convert from cents to dollars)
            compareAtPrice: this.product.variants && this.product.variants[0] ? this.product.variants[0].price / 100 : 0, // Regular price for comparison
            imagesrc: this.product.featured_image ? this.product.featured_image : "https://cdn.shopify.com/s/files/1/0000/0001/0002/files/placeholder.png?v=1234567890",
            sellingPlanID: sellingPlanId
        };
        console.log("Product Data:", this.itemData);
        this.itemData.collectionId = this.dataset.collection;

        this.addEventListeners();
        this.initializeProductDetails();

        // Sync button state with current bundle state (important after pagination/filtering)
        this.updateAddButtonState();
    }
    disconnectedCallback() {
        if(this.bundleState) {
            this.bundleState.unsubscribe(this);
        }
    }

    addEventListeners() {
        if (this.button) {
            this.button.addEventListener("click", this.handleQuantityIncrease);
        }
        if (this.quantitySelector) {
            const decreaseBtn = this.quantitySelector.querySelector(".quantity-selector-decrease");
            const increaseBtn = this.quantitySelector.querySelector(".quantity-selector-increase");
            const inputField = this.quantitySelector.querySelector(".quantity-selector-input");
            decreaseBtn == null ? void 0 : decreaseBtn.addEventListener("click", this.handleQuantityDecrease);
            increaseBtn == null ? void 0 : increaseBtn.addEventListener("click", this.handleQuantityIncrease);
            inputField == null ? void 0 : inputField.addEventListener("change", this.handleQuantityChange);
        }   
    }
    initializeProductDetails() {
        if (!this.itemData) return;

        const productName = this.itemData.name || "Unknown Product";
        const sellingPlanPrice = this.itemData.price || 0;
        const comparePrice = this.itemData.compareAtPrice || 0;

        const priceElement = this.querySelector(".price-item:not(.price-item--subscription-label):not(#product-compare-price)");
        const comparePriceElement = this.querySelector("#product-compare-price");
        const imageElement = this.querySelector(".product-card__image");
        
        // Display selling plan price (update the main price element)
        if (priceElement) priceElement.textContent = sellingPlanPrice % 1 === 0 ? `$${sellingPlanPrice.toFixed(0)}` : `$${sellingPlanPrice.toFixed(2)}`;
        
        // Update compare at price if needed - the HTML already shows it, but JS can override if needed
        if (comparePriceElement && comparePrice > sellingPlanPrice) {
            // The HTML already handles this, but we can update dynamically if needed
            const sElement = comparePriceElement.querySelector('s');
            if (sElement) {
                sElement.textContent = comparePrice % 1 === 0 ? `$${comparePrice.toFixed(0)}` : `$${comparePrice.toFixed(2)}`;
            }
        } else if (comparePriceElement) {
            // Hide compare price if it's not higher than selling plan price
            comparePriceElement.style.display = 'none';
        }
        
        if (imageElement && this.itemData.imagesrc) {
            imageElement.src = this.itemData.imagesrc;
            imageElement.alt = productName;
        }
    }
    
    handleStateChange(changeType) {
        this.updateQuantityButtonStates();
        this.updateAddButtonState();

    }

    //Quantity Selector Interactions
    handleQuantityDecrease() {
        if (!this.quantitySelector) return;
        const quantityInput = this.quantitySelector.querySelector(".quantity-selector-input");

        console.log("handleQuantityDecrease called");
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        if (currentValue > 0) {
            const newValue = currentValue - 1;
            quantityInput.value = newValue;
            this.bundleState.removeBundleItem(this.itemData.variantID);
        }
        this.updateQuantityButtonStates();
    }

    handleQuantityIncrease() {
        this.bundleState.addBundleItem(this.itemData.variantID, this.itemData)
        if (!this.quantitySelector) return;
        if (this.bundleState.currentQuantity >= this.bundleState.maxBundleQuantity) return;
        console.log("handleQuantityIncrease called");

        const quantityInput = this.quantitySelector.querySelector(".quantity-selector-input");
        const currentValue = parseInt(quantityInput.value, 10) || 0;
            
        const newValue = currentValue + 1;
        quantityInput.value = newValue;
        this.updateQuantityButtonStates();
        this.updateAddButtonState();
    }

    handleQuantityChange(event) {
        if (!this.quantitySelector) return;
        
        const quantityInput = event.target;
        let newValue = parseInt(quantityInput.value, 10);
        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
            quantityInput.value = newValue;
        }

        var _a;
        const currentCount = ((_a = this.bundleState.bundleItems[this.product.variantID]) == null ? void 0 : _a.quantity) || 0;
        const bundleCapacity = this.bundleState.maxBundleQuantity - this.bundleState.currentQuantity + currentCount;
        if (newValue > currentCount){

            if(newValue <= bundleCapacity) {
                //add newvalue - currentcount times
                // this.bundleState.addBundleItem(this.product.variantID, itemData)
            } else {
                //too much quantity requested
            }
        } else if( newValue < currentCount) {
            //remove currentcount - newvalue times
            // this.bundleState.removeBundleItem(this.product.variantID);
        }
        this.updateQuantityButtonStates();
    }

    updateQuantityButtonStates() {
        if (!this.quantitySelector) return;

        const decreaseBtn = this.quantitySelector.querySelector("quantity-selector-decrease");
        const increaseBtn = this.quantitySelector.querySelector("quantity-selector-increase");
        const quantityInput = this.quantitySelector.querySelector("quantity-selector-input");
        if (!decreaseBtn || !increaseBtn || !quantityInput) return;

        const currentValue = parseInt(quantityInput.value, 10) || 0;
        decreaseBtn.disabled = currentValue <= 0;
        const isAtCapacity = this.bundleState.currentQuantity >= this.bundleState.maxBundleQuantity;
        increaseBtn.disabled = isAtCapacity;

        if (this.bundleState.bundleItems[this.itemData.variantID] == null) {
            this.quantitySelector.classList.add("hidden");
            this.button.classList.remove("hidden");
        } else {
            this.quantitySelector.classList.remove("hidden");
            this.button.classList.add("hidden");
        }
    }

    updateAddButtonState(){
        
        if(!this.button || this.quantitySelector) return;
        const Added = this.bundleState.bundleItems.hasOwnProperty([this.itemData.variantID]);
        console.log(this.bundleState.bundleItems[this.itemData.variantID]);
        const toDisable = Added || this.bundleState.currentQuantity >= this.bundleState.maxBundleQuantity;
        this.button.disabled = toDisable;
        this.button.innerHTML = Added ? "ADDED TO BAG":"ADD TO BAG";
    }
}
customElements.define("bundle-product-card", BundleProductCard);


var Sidebar = class extends HTMLElement {
    constructor() {
        super();
        this.bundleState = null;
        this.addToCartButtons = null;
        this.isExpanded = false;
        this.isMobile = window.innerWidth <= 749;
        this.itemsContainer = null;
        this.bundlePriceElement = null;
        this.bundleItemsWrapper = null;
    }

    connectedCallback(){
        
        BundleStateManager.initBundleState.call(this);
        this.bundleState.subscribe(this, this.handleStateChange);
        this.initializeElements();
        this.addEventListeners();
        window.addEventListener("resize", () => {
            this.isMobile = window.innerWidth <= 749;
            if(!this.isMobile){
                this.classList.remove("expanded");
                this.isExpanded = false;
                if (this.bundleItemsWrapper) {
                    this.bundleItemsWrapper.style.display = "";
                }
            }
        });
    }

    initializeElements() {
        this.addToCartButton = this.querySelector(".bundle-add-to-cart");
        this.itemsContainer = this.querySelector(".bundle-items-container");
        this.bundlePriceElement = this.querySelector(".bundle-price");
        this.productsCountElement = document.querySelector(".bundle-selection-count.products");
        this.bundleItems = document.querySelectorAll(".bundle-item");

        this.handleStateChange("initialization");
    }

    addEventListeners() {
        this.addToCartButton.addEventListener("click", () => this.bundleState.AddToCart());
    }

    handleStateChange(changeType) {
        this.updateSelectionCounts();
        this.updateBundlePrice();
        this.setBundleItems();
        this.setSidebarState();
        this.setAddToCartButtonState();
    }

    updateSelectionCounts() {
        if (this.productsCountElement) {
            const selectedProducts = this.bundleState.currentQuantity;
            const maxProducts = this.bundleState.maxBundleQuantity || 0;
            if(this.bundleState.currentQuantity >= this.bundleState.maxBundleQuantity) {
                this.productsCountElement.textContent = 'Add Bundle to Bag';
            } else{
                this.productsCountElement.textContent = `${selectedProducts}/${maxProducts} ${window.kkbSettings.bundle_selection_count_text}`;
            }
        }
    }

    updateBundlePrice() {
        if (this.bundlePriceElement) {
            const totalPrice = this.bundleState.totalPrice;
            const totalComparePrice = this.bundleState.totalComparePrice;
            
            // Format selling plan price
            const formattedPrice = totalPrice.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0
            });
            
            // Update main price
            this.bundlePriceElement.textContent = formattedPrice;
            
            // Show compare price if there are savings
            if (totalComparePrice > totalPrice && totalComparePrice > 0) {
                const formattedComparePrice = totalComparePrice.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0
                });
                
                // Look for or create compare price element
                let comparePriceElement = this.querySelector('.bundle-compare-price');
                if (!comparePriceElement) {
                    comparePriceElement = document.createElement('span');
                    comparePriceElement.className = 'bundle-compare-price small-caption';
                    comparePriceElement.style.textDecoration = 'line-through';
                    comparePriceElement.style.opacity = '0.7';
                    this.bundlePriceElement.parentNode.appendChild(comparePriceElement);
                }
                comparePriceElement.textContent = formattedComparePrice;
                comparePriceElement.style.display = 'inline';
            } else {
                // Hide compare price if no savings
                const comparePriceElement = this.querySelector('.bundle-compare-price');
                if (comparePriceElement) {
                    comparePriceElement.style.display = 'none';
                }
            }
        }
    }

    setBundleItems() {
        this.bundleItems = document.querySelectorAll(".bundle-item:not([data-bundle-item-template])");
        let i = 0;
        for (const item in this.bundleState.bundleItems) {
            for (var j = 0; j < this.bundleState.bundleItems[item].quantity; j++) {
                if (this.bundleItems[i]) {
                    var details = this.bundleItems[i].querySelector(".bundle-item__details");
                    if (details) {
                        details.classList.remove("hidden");
                    }
                    this.bundleItems[i].classList.add("bundle-item--filled");
                    this.bundleItems[i].classList.remove("bundle-item--empty");
                    //Set data
                    // this.bundleItems[i].dataset.variantId = this.bundleState.bundleItems[item].itemData.variantID;
                    this.bundleItems[i].querySelector(".bundle-item__title").innerText = this.bundleState.bundleItems[item].itemData.name;
                    this.bundleItems[i].querySelector(".bundle-item__subtitle").innerText = this.bundleState.bundleItems[item].itemData.subtitle;
                    
                    this.bundleItems[i].querySelector(".bundle-item__image").src = this.bundleState.bundleItems[item].itemData.imagesrc;
                    var removeButton = this.bundleItems[i].querySelector(".bundle-item__remove");
                    removeButton.replaceWith(removeButton.cloneNode(true));
                    this.bundleItems[i].querySelector(".bundle-item__remove").addEventListener("click", () => {
                        this.bundleState.removeBundleItem(this.bundleState.bundleItems[item].itemData.variantID);
                    });
                    i++;
                }
            }
        }
        for (; i < this.bundleItems.length; i++) {
            if (this.bundleItems[i]) {
                var details = this.bundleItems[i].querySelector(".bundle-item__details");
                if (details) {
                    details.classList.add("hidden");
                }
                this.bundleItems[i].classList.remove("bundle-item--filled");
                this.bundleItems[i].classList.add("bundle-item--empty");
                //SetPlaceholder
                this.bundleItems[i].dataset.variantId = "";
                this.bundleItems[i].querySelector(".bundle-item__title").innerText = "";
                this.bundleItems[i].querySelector(".bundle-item__subtitle").innerText = "";
                this.bundleItems[i].querySelector(".bundle-item__image").src = "https://cdn.shopify.com/s/files/1/0000/0001/0002/files/placeholder.png?v=1234567890"; // Placeholder image
                var removeButton = this.bundleItems[i].querySelector(".bundle-item__remove");

            }
        }
    }

    setSidebarState() {
        if (this.bundleState.currentQuantity == this.bundleState.maxBundleQuantity) {
            this.classList.add("expanded");
            this.isExpanded = true;
            if (this.itemsContainer) {
                this.itemsContainer.style.display = "block";
            }
        } else {
            this.classList.remove("expanded");
            this.isExpanded = false;
            if (this.itemsContainer) {
                this.itemsContainer.style.display = "";
            }
        }

    }

    setAddToCartButtonState() {
        if (this.addToCartButton) {
            this.addToCartButton.disabled = !(this.bundleState.currentQuantity === this.bundleState.maxBundleQuantity);
            this.addToCartButton.classList.toggle("disabled", this.addToCartButton.disabled);
        }
    }
}

customElements.define("bundle-sidebar", Sidebar);
